import React from 'react';
import LocationTemplate from './LocationTemplate';

const DunnPage: React.FC = () => {
  return (
    <LocationTemplate
      cityName="Dunn"
      stateName="North Carolina"
      countyName="Harnett"
      zipCodes={["28334"]}
      latitude={35.3069}
      longitude={-78.609}
      population={9750}
      historicalFact="Incorporated in 1887, named for early settler Bennett Dunn."
      nearbyTowns={[
        "Fayetteville, NC",
        "Benson, NC",
        "Clinton, NC",
        "Erwin, NC",
        "Angier, NC",
        "Newton Grove, NC",
        "Lillington, NC",
        "Coats, NC"
      ]}
    />
  );
};

export default DunnPage;